import { useQuery, gql } from '@apollo/client'
import { useEffect, useState } from 'react'
import { getToken, getCookie } from 'resources'

export const useDoIHaveNewMesssage = (params) => {
  const [hasToken, setHasToken] = useState(false)

  useEffect(() => {
    const checkToken = async () => {
      const token = await getToken()
      if (!token) {
        const cookieToken = await getCookie(process.env.REACT_APP_COOKIE_NAME)
        setHasToken(!!cookieToken)
      } else {
        setHasToken(!!token)
      }
    }
    checkToken()
  }, [])

  const { refetch } = useQuery(DO_I_HAVE_NEW_MESSAGE, {
    skip: !hasToken,
    pollInterval: 180000,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onError: (error) => {
      // Se falhar por não autenticado, tentar novamente após 2 segundos
      if (error?.graphQLErrors?.[0]?.extensions?.code === 'UNAUTHENTICATED') {
        setTimeout(() => refetch(), 2000)
      }
    },
    ...params,
  })
}

export const useUpdateDoIHaveNewMesssage = (params) => {
  const [hasToken, setHasToken] = useState(false)

  useEffect(() => {
    const checkToken = async () => {
      const token = await getToken()
      if (!token) {
        const cookieToken = await getCookie(process.env.REACT_APP_COOKIE_NAME)
        setHasToken(!!cookieToken)
      } else {
        setHasToken(!!token)
      }
    }
    checkToken()
  }, [])

  const { refetch } = useQuery(DO_I_HAVE_NEW_MESSAGE, {
    skip: !hasToken,
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
    onError: (error) => {
      // Se falhar por não autenticado, tentar novamente após 2 segundos
      if (error?.graphQLErrors?.[0]?.extensions?.code === 'UNAUTHENTICATED') {
        setTimeout(() => refetch(), 2000)
      }
    },
    ...params,
  })
}

const DO_I_HAVE_NEW_MESSAGE = gql`
  query DoIHaveNewMessage {
    doIHaveNewMessage {
      message
      payload {
        ... on Live {
          id
          title
          description
          icon
          liveDate
          endDate
          linkYoutube
          linkSambaTech
          attachment
        }
        ... on MessageStringPayload {
          payload
        }
        ... on MessageCommunityNotification {
          count
        }
      }
    }
  }
`
